import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private loading$: Observable<boolean> = this.loadingSubject as Observable<boolean>;

  constructor() {
    // Service initialization
  }

  show(): void {
    this.loadingSubject.next(false);
  }

  hide(): void {
    this.loadingSubject.next(true);
  }

  get loading(): Observable<boolean> {
    return this.loading$;
  }
}
